import type { DatasetDatasourceResponse } from '../openapi/types';
import { HarvestStatesEnum } from '../openapi/types/HarvestStatesEnum';

type DatasourceState = DatasetDatasourceResponse['state'];

export const DATASOURCE_LIST_PAGE_SIZE = 1000;
export const DATASOURCE_POLL_INTERVAL = 5_000;
export const DATASOURCE_STUCK_AFTER_MINUTES = 15;

const DATASOURCE_STUCK_AFTER = DATASOURCE_STUCK_AFTER_MINUTES * 60_000;

/** `null` je zdroj, který se ještě nikdy neharvestoval. */
const HARVESTING_ENABLED_STATES: DatasourceState[] = [
  HarvestStatesEnum.PROCESSED,
  HarvestStatesEnum.FAILED,
  null,
];

const HARVEST_RUNNING_STATES: DatasourceState[] = [
  HarvestStatesEnum.WAITING_FOR_PROCESSING,
  HarvestStatesEnum.PROCESSING,
];

export const isHarvestingEnabled = (state: DatasourceState) =>
  HARVESTING_ENABLED_STATES.includes(state);

export const isHarvestRunning = (state: DatasourceState) => HARVEST_RUNNING_STATES.includes(state);

export const needsPolling = (datasources: Pick<DatasetDatasourceResponse, 'state'>[]) =>
  datasources.some(({ state }) => isHarvestRunning(state));

/** Měří se od `edited`, protože čas poslední změny stavu BE nevrací. */
export const isHarvestStuck = (
  { state, edited }: Pick<DatasetDatasourceResponse, 'state' | 'edited'>,
  now: number,
) => isHarvestRunning(state) && now - Date.parse(edited) > DATASOURCE_STUCK_AFTER;
